import React, {useState} from 'react';
import {Card, Form} from 'react-bootstrap';
import {PfButton} from '@profabric/react-components';
import {DateTimePicker} from 'react-tempusdominus-bootstrap';

export default function ModalAddPicGps(props) {
  const [file, setFile] = useState({file: null, location: '', datetime: new Date()});
  const [error, setError] = useState('');
  const [b64, setB64] = useState('');

  const handleValidation = () => {
    let errors = '';
    let formIsValid = true;

    if (file.file === null) {
      formIsValid = false;
      errors = errors + ', กรุณาใส่รูปอย่างน้อย 1 รูป';
    }

    if (file.location === '') {
      formIsValid = false;
      errors = errors + ', กรุณาใส่พิกัดรูป';
    }

    if (file.datetime === null) {
      formIsValid = false;
      errors = errors + ', กรุณาใส่วันเวลา';
    }

    console.log(file.location);
    if (!validateNewPlantsForm(file.location)) {
      formIsValid = false;
      errors = errors + ', พิกัดผิด ต้องเป็นรูปแบบ x.xx,y.yy';
    }

    if (!formIsValid) setError(`Required: ${errors}`);
    return formIsValid;
  };

  function validateNewPlantsForm(latlng){
    var latlngArray = latlng.split(",");
    // console.log(latlngArray);
    for(var i = 0; i < latlngArray.length; i++) {
      // console.log(isNaN(parseFloat(latlngArray[i])) || parseFloat(latlngArray[i]) < -127 || parseFloat(latlngArray[i]) > 75);
      if(isNaN(parseFloat(latlngArray[i])) || parseFloat(latlngArray[i]) < -180 || parseFloat(latlngArray[i]) > 180){
        return false;
      }
    }
    return true;
  }

  const handleSubmit = async () => {
    if (handleValidation()) {
      setLoading(true);
      try {
        const result = await props.onUpload(file);
        setLoading(false);
      } catch (error) {}
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file); //ปัญหา
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const photoUpload = async (e, id) => {
    e.preventDefault();
    const _file = e.target.files[0];
    if (_file) {
      console.log(_file);
      let base64 = await convertToBase64(_file);
      setB64(base64);
      setFile((prevState) => ({
        ...prevState,
        file: _file
      }));
    }
  };

  const [isLoading, setLoading] = useState(false);
  return (
    <div>
      <Form>
        <div className="row">
          <Form.Group className="mb-3 col-md-12">
            <div className="custom-file">
              <input
                type="file"
                onChange={(e) => {
                  photoUpload(e, 1);
                }}
                className="custom-file-input"
                accept=".jpef, .png, .jpg"
                id="customFile"
              />
              <label className="custom-file-label" htmlFor="customFile">
                {file.file
                  ? file.file.name
                  : 'รูปที่ 1 | ขนาดภาพไม่เกิน 4MB'}
              </label>
            </div>
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <Form.Label>ระบุวันและเวลาบนรูป</Form.Label>
            <DateTimePicker
              date={file.datetime}
              format="YYYY-MM-DD HH:mm"
              onChange={(e) => {
                console.log(file);
                // const temp = file.map((el) => {
                //   if (el.id === 1) return {...el, datetime: e.date.toDate()};
                //   else return el;
                // });

                // console.log(temp);
                // setFile(temp);
                setFile((prevState) => ({
                  ...prevState,
                  datetime: e.date.toDate()
                }));
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <Form.Label>กรอกพิกัดบนรูปในรูปแบบ x.xx,y.yy</Form.Label>
            <Form.Control
              type="text"
              value={file.location}
              onChange={(e) => {
                console.log(file);
                setFile((prevState) => ({
                  ...prevState,
                  location: e.target.value.trim()
                }));
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <Card className="col-12">
              <Card.Body>
                <div
                  className="container"
                  style={{
                    height: '28vh',
                    width: '100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center top',
                    backgroundImage:
                      b64 === ''
                        ? 'url("https://api-passport.advanceagro.net/img/car_temp.png")'
                        : ''
                  }}
                >
                  <img
                    className="rounded mx-auto d-block"
                    style={{
                      maxHeight: '100%',
                      maxWidth: '100%'
                    }}
                    src={b64 !== '' ? b64 : ''}
                  ></img>
                </div>
              </Card.Body>
            </Card>
          </Form.Group>
        </div>
      </Form>
      <p className="text-danger">{error}</p>
      <PfButton
        theme="success"
        block
        loading={isLoading}
        type="button"
        onClick={handleSubmit}
      >
        ท่านยืนยันในการอัพโหลด
      </PfButton>
    </div>
  );
}
